/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from 'react'

import { Container, Teams } from './styles'
import { Alert, Avatar, Col, Flex, Row, Tag, Typography } from 'antd'

import { useTeams } from '~/hooks/Teams/useListTeams'
import { LoadingIndicator } from '../../Dashboard/Tasks/styles'
import {
  BankOutlined,
  BranchesOutlined,
  DollarOutlined,
  KeyOutlined,
  LoadingOutlined,
  NumberOutlined,
  ProfileOutlined,
  UserOutlined,
  WalletOutlined,
} from '@ant-design/icons'
import { useContributor } from '~/hooks/Contributors/useContributor'
import { format } from 'date-fns'
import { translate } from '~/utils/locale'
import CurrencyFormatter from '../../Misc/CurrencyFormater'

const ContributorFinancial: React.FC = () => {
  const { data, isLoading: isLoadingContributor } = useContributor()
  const { teams, isLoading } = useTeams()

  if (isLoading || !teams || isLoadingContributor || !data) {
    return (
      <LoadingIndicator>
        <LoadingOutlined style={{ fontSize: 34, margin: 'auto' }} spin />
      </LoadingIndicator>
    )
  }

  const findParentArraysContainingId = (idToCheck: string) => {
    return teams.filter((t) =>
      t.contributorsTeams.some((ct) => ct.collaborator.id === idToCheck),
    )
  }

  const result = findParentArraysContainingId(data.id)

  const formattedDate = (date: any) => format(new Date(date), `dd/MM/yyyy '`)

  const { Title, Text } = Typography

  return (
    <Container>
      <Alert
        message="Valores acordados para pagar para Equipe/Colaborador"
        description="Os valores exibidos foram extraídos do cadastro da equipe desse
          colaborador."
        type="info"
        showIcon
      />

      <Teams>
        {result.length > 0 ? (
          <Fragment>
            {result.map((team) => (
              <>
                <Row gutter={12}>
                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <DollarOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate('TeamsComponentTabFinancial.valueText')}
                        </Title>
                        {team.amount_to_receive === null ? (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        ) : (
                          <Text>
                            <CurrencyFormatter value={team.amount_to_receive} />
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>

                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <DollarOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          Dia de Pagamento
                        </Title>
                        {team.payment_day === null ? (
                          <Text>Nenhuma data de pagamento fornecida.</Text>
                        ) : (
                          <Text>
                            {formattedDate(
                              team.payment_day ? team.payment_day : new Date(),
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>
                </Row>
                <Row style={{ marginTop: 14 }}>
                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <NumberOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate(
                            'TeamsComponentTabFinancial.numberBankText',
                          )}
                        </Title>
                        {team.number_bank ? (
                          <Text>{team.number_bank}</Text>
                        ) : (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>

                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <BankOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate('TeamsComponentTabFinancial.nameBankText')}
                        </Title>
                        {team.name_bank ? (
                          <Text>{team.name_bank}</Text>
                        ) : (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>

                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <UserOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate(
                            'TeamsComponentTabFinancial.typePersonAccountText',
                          )}
                        </Title>
                        {team.type_account_bank ? (
                          <>
                            {team.type_account_bank === 'current' ? (
                              <Text>
                                {translate(
                                  'TeamsComponentTabFinancial.currentText',
                                )}
                              </Text>
                            ) : (
                              <Text>
                                {translate(
                                  'TeamsComponentTabFinancial.savingsText',
                                )}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>
                </Row>

                <Row style={{ marginTop: 14 }}>
                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <BranchesOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate('TeamsComponentTabFinancial.agencyText')}
                        </Title>
                        {team.agency_bank ? (
                          <Text>{team.agency_bank}</Text>
                        ) : (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>

                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <WalletOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate('TeamsComponentTabFinancial.accountText')}
                        </Title>
                        {team.account_bank ? (
                          <Text>{team.account_bank}</Text>
                        ) : (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>

                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <ProfileOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate(
                            'TeamsComponentTabFinancial.typeAccountText',
                          )}
                        </Title>
                        {team.personal_bank ? (
                          <>
                            {team.personal_bank === 'physics' ? (
                              <Text>
                                {translate(
                                  'TeamsComponentTabFinancial.physicalText',
                                )}
                              </Text>
                            ) : (
                              <Text>
                                {translate(
                                  'TeamsComponentTabFinancial.juridicText',
                                )}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>
                </Row>

                <Row style={{ marginTop: 14 }}>
                  <Col span={8}>
                    <Flex gap={10}>
                      <Avatar
                        shape="square"
                        icon={
                          <KeyOutlined
                            style={{ fontSize: 12, color: '#464545' }}
                          />
                        }
                        size="small"
                        style={{ background: '#DADADA' }}
                      />
                      <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                          {translate('TeamsComponentTabFinancial.pixText')}
                        </Title>
                        {team.key_pix ? (
                          <Text>{team.key_pix}</Text>
                        ) : (
                          <Text>
                            {translate(
                              'TeamsComponentTabFinancial.undefinedText',
                            )}
                          </Text>
                        )}
                      </div>
                    </Flex>
                  </Col>
                </Row>
              </>
            ))}
          </Fragment>
        ) : (
          <Tag color="red">Você não está em nenhuma equipe.</Tag>
        )}
      </Teams>
    </Container>
  )
}

export default ContributorFinancial
